import React from 'react';
import PropTypes from 'prop-types';
import css from './BriefSection.css';
import BriefGeneratorButton from './BriefGeneratorButton';
import withTranslate from '../../../../containers/widgets/withTranslate';
import { INSIGHTS_KEY_PREFIX } from '../consts';

const BriefSection = ({ availableBriefs, currentBrief, onBriefGenerator, translate }) => (
    <div className={css.briefSection}>
        <span className={css.question}>{translate(`${INSIGHTS_KEY_PREFIX}.BRIEF_TITLE`)}</span>
        <div>
            {availableBriefs.map(creativeType => {
                return (
                    <BriefGeneratorButton
                        key={creativeType}
                        isActive={currentBrief === creativeType}
                        onBriefGenerator={onBriefGenerator}
                        generatorKey={creativeType}
                        buttonClassName={css.buttonClassName}
                    />
                );
            })}
        </div>
    </div>
);

BriefSection.propTypes = {
    availableBriefs: PropTypes.arrayOf(PropTypes.string).isRequired,
    currentBrief: PropTypes.string,
    onBriefGenerator: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withTranslate(BriefSection);
